<template>
  <div>
    <section class="recommendations_Container  py-2 p-md-3 ">
      <h2 class="px-2">
        Our Recommendations are designed to:
      </h2>
      <div class="d-flex flex-column flex-md-row recommendations-content">
        <div class="d-flex flex-row align-items-center p-2">
          <img
            src="@/assets/images/icons/rebalance.svg"
          >
          <div
            v-if="contextBarcode.haveDNAData && contextBarcode.duBarcode === ''"
            class="ml-1"
          >
            <h4> Optimize</h4>
            <p> Make scientifically-informed shifts in lifestyle.</p>
          </div>
          <div
            v-else
            class="ml-1"
          >
            <h4> Re-balance</h4>
            <p> Some of your gut bacteria that are not in their optimal range.</p>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center p-2">
          <img
            src="@/assets/images/icons/strengthen.svg"
          >
          <div class="ml-1">
            <h4>Strengthen</h4>
            <p> Build stronger prevention for symptoms you could be predisposed to.</p>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center p-2">
          <img
            src="@/assets/images/icons/maintain.svg"
          >
          <div class="ml-1">
            <h4> Maintain</h4>
            <p>Help you maintain your unique nutrient needs, as defined by your {{ contextBarcode.haveDNAData? 'DNA': 'Gut Biology' }}.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      contextBarcode: 'auth/GET_CONTEXT_BARCODE',
    }),
  },
}
</script>
<style lang="scss">
.recommendations_Container{

        background-color: transparent;
        h4,h2{
          color: black;
          font-weight: 700;
        }
        p{
          margin-bottom: 0;
          color: #515151;
        }
        img{
          width: 4rem;
          height: 4rem;
        }
         @media (min-width: 768px) and (max-width: 1024px) {
        .recommendations-content{
          flex-direction: column !important;
        }
      }

}
</style>
